module.exports = __webpack_public_path__ + "img/live1.5a2a28a1.jpg";